import { BaseEntity } from "@memberjunction/core";
import { RegisterClass } from "@memberjunction/global";
import { IzzyOrganizationActionEntity } from "../generated/entity_subclasses.js";

/**
 * Client-safe extended OrganizationActionEntity with lifecycle methods.
 *
 * For server-side use with credential resolution, the OrganizationActionEntityExtended
 * in IzzyLib extends this class and registers with higher priority.
 */
@RegisterClass(BaseEntity, 'Organization Actions')
export class OrganizationActionEntityExtendedClient extends IzzyOrganizationActionEntity {

    // --- Lifecycle ---

    Disable(): void {
        this.Status = 'Disabled';
    }

    Enable(): void {
        this.Status = 'Active';
    }
}

export function LoadOrganizationActionEntityExtendedClient(): void {}
